// extracted by mini-css-extract-plugin
export default {"mealTable":"gpPWmVdfHMhzc0ufE3zE"};